import { MouseEvent } from 'react';

export interface ToggleOption {
  value: string;
  label: string;
  disabled?: boolean;
  disabledTitle?: string;
}

interface ToggleGroupProps {
  ariaLabel: string;
  options: ToggleOption[];
  selected: string;
  onChange?: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

export default function ToggleGroup({
  ariaLabel, options, selected, onChange, className = '',
}: ToggleGroupProps) {
  return (
    <ul
      role="group"
      aria-label={ariaLabel}
      className={`flex flex-row text-xs bg-pipbg border border-pipgrey-border rounded-lg ${className}`}
    >
      {options.map((option) => (
        <li
          key={option.value}
          className={`w-fit px-4 py-2 rounded-md ${selected === option.value ? 'bg-primary text-white' : ''}`}
        >
          <button
            type="button"
            value={option.value}
            onClick={option.disabled ? undefined : onChange}
            title={option.disabled ? option.disabledTitle : undefined}
            disabled={option.disabled}
            className={option.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
            aria-pressed={selected === option.value}
          >
            {option.label}
          </button>
        </li>
      ))}
    </ul>
  );
}
